"use strict";

module.exports = require("./dist/ordinal-js");



//////////////////
// WEBPACK FOOTER
// ../node_modules/ordinal-js/index.js
// module id = 3271
// module chunks = 0